<template>
  <div class="flex-row flex-wrap justify-start align-start">
    <pbc-toggle-button v-model='selections[transformsAndSource.c.id]' v-for='transformsAndSource in transformsAndSources' :key='transformsAndSource.c.id' class="max-height-collision-targets">
      <toy-from-component class="p-2" :transforms-and-source='transformsAndSource'  />
    </pbc-toggle-button>
  </div>
</template>

<script>
import { fromPairs, toPairs } from 'lodash';
import { abstractField } from "vue-form-generator";
import ToyFromComponent from '@edit/molecules/ToyFromComponent.vue';
export default {
  mixins: [ abstractField ],
  data() {
    const {partutil} = this.vfg.schema.data;
    const componentTypes = this.schema.componentTypes;
    const selectionType = this.schema.selectionType || 'cid';
    const physicsFilter = partutil.gamedata.filterComponentsByType(componentTypes);
    const physicsboxesAndSources = partutil.gamedata.findComponentsAndSourceByFilter(physicsFilter);
    const transformsAndSources = partutil.gamedata.findTransformsAndSourceForComponentsAndSource(physicsboxesAndSources);
    const selections = {};

    if (selectionType === 'cid') {
      physicsboxesAndSources.forEach( ({c}) => {
        selections[c.id] = this.value.indexOf(c.id) !== -1;
      });
    } else {
      physicsboxesAndSources.forEach( ({c}) => {
        const cid = c.id;
        console.log('check if transform for', cid, 'bla');
        const transform = partutil.gamedata.findTransformsByCid(cid)[0];
        console.log('found transform', transform, this.value);
        selections[cid] = this.value.indexOf(transform.id) !== -1;
      });
    }


    return {
      transformsAndSources,
      selections,
      selectionType,
      physicsboxesAndSources
    }
  },
  components:{
    ToyFromComponent
  },
  methods: {
  },
  watch: {
    selections: {
      handler(nv) {
        if (this.selectionType === 'cid') {
          this.value = Object.keys(fromPairs(toPairs(nv).filter( ([key,value]) => {
            return value;
          })));
        } else {
          const {partutil} = this.vfg.schema.data;
          const cids = Object.keys(fromPairs(toPairs(nv).filter( ([key,value]) => {
            return value;
          })));
          this.value = cids.map( (cid) => {
            return partutil.gamedata.findTransformsByCid(cid)[0];
          }).map( ({id}) => {
            return id;
          });
        }
      },
      deep: true
    }
  },
}
</script>
<style scoped>
.max-height-collision-targets {
  max-height:80px;
  overflow-y:auto;
}
</style>
